import type { DataCollection } from "@sentry/core";

/**
 * HUB-619: Sentry 11 replaced `sendDefaultPii` with `dataCollection` and, left unset, now
 * collects cookies, user info, every HTTP request/response body, database query data and more.
 * Hub never set `sendDefaultPii`, so v10 sent none of that. This is the v10 baseline from the
 * Sentry 10 → 11 migration guide ("If you want to keep the v10 default behavior"), shared by the
 * server and browser SDKs so neither starts sending login bodies or session cookies on upgrade.
 * Widening any category is a privacy decision for John, not a dependency bump.
 *
 * Query strings are not collected at all (stricter than v10, John 2026-10-27): they carry customer
 * searches, order ids and reset tokens, and Sentry 11 records them as their own `url.query` span
 * attribute, which the URL-redacting callbacks never see.
 */
const V10_SENSITIVE_KEY_DENYLIST = ["forwarded", "-ip", "remote-", "via", "-user"];

export const SENTRY_DATA_COLLECTION = {
  userInfo: false,
  cookies: false,
  httpHeaders: {
    request: { deny: [...V10_SENSITIVE_KEY_DENYLIST] },
    response: { deny: [...V10_SENSITIVE_KEY_DENYLIST] },
  },
  httpBodies: [],
  urlQueryParams: false,
  genAI: { inputs: false, outputs: false },
  mcp: { inputs: false, outputs: false },
  databaseQueryData: false,
  queues: false,
  graphQL: { document: false, variables: false },
  stackFrameVariables: true,
  frameContextLines: 7,
} as const satisfies DataCollection;
